import {
  getCardGroupByCustId, getCardGroupByCustDZId, getCardByQuery, getCustomizedCardByQuery, getMonthCardListAsync, getCardConcentrateByQuery, getParkCust, cardConcentrateDataTemplate, cardConcentrateDataUpload, importCardConcentrateData, getPlatCardGroupListAsync, getEhallCardListAsync, getReportingVehiclesListAsync, getCustCardSetUserListAsync, saveEhallCard, saveReportingVehicles, saveEhallCardSetChnl, saveReportingVehiclesSetChnl, saveCustCardSetUser, savePlatCardGroup, ehallCardRecharge, ehallCardAddOrDedDuration, deletePlatCardGroup, deleteEhallCard, deleteReportingVehicles, deleteCustCardSetUser, getEhallCardFillDurationList, getEhallCardInOustList, getGroupCust, getEhallCardGroupCust, getReportingVehiclesGroupCust, getEhallCardDefaultSetChnlList, getReportingVehiclesDefaultSetChnlList, loadCardDDLSource, loadCardOtherList, loadCustomizedCardOtherList, loadCardOtherListConcentrateAdd, loadCardConcentrateConcentrateEdit, getCardGroupByQuery, saveCardGroup, deleteCardGroup, synCardGroupById,
  saveCard, saveCardConcentrate, deleteCard, deleteCardCardConcentrate, synCardById, synCardConcentrateById, setCardStatus, getBlackPlateByQuery, saveBlackPlate, deleteBlackPlate, synBlackPlateById, loadCardTypeList, loadCardConcentrateTypeList, loadCarTypeList, getRechargeList,
  saveRecharge, cardConcentrateRecharge, cardConcentrateBatchRecharge, synCardConcentrateRecharge, getCardConcentrateRechargeSync, synRecharge, deleteRecharge, getCardPayList, getCarPresnetList, cardUpload, importCardData, exportCardData, exportCustomizedCardData, exportMonthCardData, exportCardConcentrateData, cardDataTemplate
} from '../../../api/card'
const state = {
}
// mutations
const mutations = {
}
// actios
const actions = {
  getCardGroupByCustId ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardGroupByCustId(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardGroupByCustDZId ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardGroupByCustDZId(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomizedCardByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCustomizedCardByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMonthCardListAsync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getMonthCardListAsync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardConcentrateByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardConcentrateByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkCust ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkCust(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardConcentrateDataTemplate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      cardConcentrateDataTemplate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  importCardConcentrateData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      importCardConcentrateData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardConcentrateDataUpload ({ commit }, param) {
    return new Promise((resolve, reject) => {
      cardConcentrateDataUpload(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardListAsync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardListAsync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getReportingVehiclesListAsync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getReportingVehiclesListAsync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustCardSetUserListAsync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCustCardSetUserListAsync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPlatCardGroupListAsync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getPlatCardGroupListAsync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveEhallCard ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveEhallCard(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveReportingVehicles ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveReportingVehicles(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveEhallCardSetChnl ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveEhallCardSetChnl(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveReportingVehiclesSetChnl ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveReportingVehiclesSetChnl(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCustCardSetUser ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveCustCardSetUser(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  savePlatCardGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      savePlatCardGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ehallCardRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      ehallCardRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ehallCardAddOrDedDuration ({ commit }, param) {
    return new Promise((resolve, reject) => {
      ehallCardAddOrDedDuration(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteEhallCard ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteEhallCard(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteReportingVehicles ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteReportingVehicles(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteCustCardSetUser ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteCustCardSetUser(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deletePlatCardGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deletePlatCardGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardFillDurationList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardFillDurationList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardInOustList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardInOustList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getGroupCust ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getGroupCust(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardGroupCust ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardGroupCust(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getReportingVehiclesGroupCust ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getReportingVehiclesGroupCust(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardDefaultSetChnlList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardDefaultSetChnlList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getReportingVehiclesDefaultSetChnlList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getReportingVehiclesDefaultSetChnlList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardDDLSource ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadCardDDLSource(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardOtherList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadCardOtherList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCustomizedCardOtherList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadCustomizedCardOtherList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardOtherListConcentrateAdd ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadCardOtherListConcentrateAdd(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardConcentrateConcentrateEdit ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadCardConcentrateConcentrateEdit(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardGroupByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardGroupByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCardGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveCardGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteCardGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteCardGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synCardGroupById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synCardGroupById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCard ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveCard(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCardConcentrate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveCardConcentrate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteCard ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteCard(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteCardCardConcentrate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteCardCardConcentrate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synCardById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synCardById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synCardConcentrateById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synCardConcentrateById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setCardStatus ({ commit }, param) {
    return new Promise((resolve, reject) => {
      setCardStatus(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBlackPlateByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getBlackPlateByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveBlackPlate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveBlackPlate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteBlackPlate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteBlackPlate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synBlackPlateById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synBlackPlateById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardTypeList ({ commit }) {
    return new Promise((resolve, reject) => {
      loadCardTypeList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCardConcentrateTypeList ({ commit }) {
    return new Promise((resolve, reject) => {
      loadCardConcentrateTypeList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadCarTypeList ({ commit }) {
    return new Promise((resolve, reject) => {
      loadCarTypeList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRechargeList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRechargeList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardConcentrateRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      cardConcentrateRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardConcentrateBatchRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      cardConcentrateBatchRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synCardConcentrateRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synCardConcentrateRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardConcentrateRechargeSync ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardConcentrateRechargeSync(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteRecharge ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteRecharge(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardPayList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCardPayList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCarPresnetList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCarPresnetList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardUpload ({ commit }, param) {
    return new Promise((resolve, reject) => {
      cardUpload(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  importCardData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      importCardData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportCardData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      exportCardData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportCustomizedCardData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      exportCustomizedCardData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportMonthCardData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      exportMonthCardData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportCardConcentrateData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      exportCardConcentrateData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardDataTemplate ({ commit }) {
    return new Promise((resolve, reject) => {
      cardDataTemplate().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/card/card.js